import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import { useParams } from 'react-router-dom';
import GeneralRequestHelper from '../../../../../Helpers/GeneralRequestHelper';
import Swal from 'sweetalert2'


export const AdminEditUser = () => {
    const { t } = useTranslation()
    const [data, setData] = useState([]);
    const [detail, setDetail] = useState([]);

    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);
    const [sections, setSections] = useState('');
    const [userData, setUserData] = useState([]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/admin/User/UpdateUser";
            await axios({
                method: 'PUT',
                url: url,
                data: {
                    id: data.id,
                    username: document.getElementById("username").value,
                    fullName: document.getElementById("fullName").value,
                    roleId: document.getElementById("roleId").value,
                    createdAt: data.createdAt,
                    lastLogin: data.lastLogin,
                    expiryDate: document.getElementById("expiryDate").value,
                    isTrial: data.isTrial,
                    isVerified: data.isVerified,
                    isInvidual: data.isInvidual,
                    isStudent: data.isStudent,
                    isManager: data.isManager,
                    schoolId: detail.schoolId,
                    classId: detail.classId,
                    sectionId: document.getElementById("sectionId").value,
                    userNote: ".",
                    status: "."
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {

                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err);
        }
    }
    const getUser = async (e) => {

        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/admin/User/GetUserById";
            await axios({
                method: 'GET',
                url: url,
                params: {
                    userId: params['id']
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data']['user'])
                        setDetail(res.data['data']['detail'])

                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err);
        }
        setLoading(false);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/admin/Role/GetList";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {

                if (res.status === 200) {
                    if (res.data['success']) {
                        setRoles(res.data['data']);
                    }
                    else {
                        alert("hata")
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            alert(err.message)
            setMsg(err);
        }
        setLoading(false);
    }
    const getSections = async () => {
        setLoading(true);
        try {
            await GeneralRequestHelper("/api/admin/SectionManager/GetList", "get", "", user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setSections(res.data['data'])
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
        setLoading(false);
    }
    useEffect(() => {
        getUser();

        fetchData();

        getSections();

    }, [])

    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <div style={{ textAlign: "center" }}>
                <h1>{t("editUser")}</h1>
            </div>

            <h4>{msg}</h4>
            {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}

            {!loading && (
                <form onSubmit={handleSubmit} >
                    <div class="mb-3">
                        <label for="username" class="form-label">{t("email")}</label>
                        <textarea class="form-control" id="username" defaultValue={data.username} rows={1} />
                    </div>

                    <div class="mb-3">
                        <label for="fullName" class="form-label"> {t('namesurname')} </label>
                        <textarea class="form-control" id="fullName" defaultValue={data.fullName} rows={1} />
                    </div>
                    <hr />

                    <div class="mb-3">
                        <label class="form-label">{t('createdAt')}: {data.createdAt}</label>
                    </div>
                    <div class="mb-3">
                        <label class="form-label"> {t('lastLogin')} : {data.lastLogin}</label>
                    </div>


                    <hr />
                    <div class="mb-3">
                        <label class="form-label" for="expiryDate">{t("expiryDate")}</label>
                        <input type="datetime-local" class="form-control" id="expiryDate" name="expiryDate" defaultValue={data.expiryDate} />
                    </div>


                    <div class="mb-3">
                        <label for="isTrial" class="form-label">deneme kullanıcısı</label>
                        {data.isTrial ? (

                            <select id="isTrial" class="form-select" required >
                                <option key="0" value="true" selected>{t('passive')}</option>
                                <option key="1" value="false" >{t('active')}</option>
                            </select>
                        ) : (
                            <select id="isTrial" class="form-select" required >
                                <option key="1" value="false" selected>{t('active')}</option>
                                <option key="0" value="true" >{t('passive')}</option>
                            </select>
                        )}
                    </div>



                    <div class="mb-3">
                        <label for="roleId" class="form-label">Rol seçiniz</label>
                        <select id="roleId" class="form-select">
                            {roles ? (
                                roles && roles.map((dt) => {
                                    if (data.roleName === dt.roleName) {
                                        return (
                                            <option key={dt.id} value={dt.id} selected>{dt.roleName}</option>
                                        );
                                    }
                                    else {
                                        return (
                                            <option key={dt.id} value={dt.id} >{dt.roleName}</option>
                                        );
                                    }
                                })
                            ) : (
                                <p>{t("reloadWarning")}</p>
                            )
                            }
                        </select>
                    </div>

                    <div class="mb-3">
                        <label for="sectionId" class="form-label">Bölüm seçiniz</label>
                        <select id="sectionId" class="form-select">
                            {sections ? (
                                sections && sections.map((dt) => {
                                    if (detail.sectionName === dt.sectionName) {
                                        return (
                                            <option key={dt.id} value={dt.id} selected>{dt.sectionName}</option>
                                        );
                                    }
                                    else {
                                        return (
                                            <option key={dt.id} value={dt.id} >{dt.sectionName}</option>
                                        );
                                    }
                                })
                            ) : (
                                <p>{t("reloadWarning")}</p>
                            )
                            }
                        </select>
                    </div>


                    <div class="mb-3">
                        <label for="schoolId" class="form-label"> {t('schoolId')} </label>
                        <textarea class="form-control" id="schoolId" defaultValue={data.schoolId} rows={1} />
                    </div>

                    <div className='d-flex justify-content-center'>
                        <button type="submit" class="btn btn-primary btn-lg">{t('update')}</button>
                    </div>

                </form>
            )}

        </div>
    );
};
export default AdminEditUser;
